import { HugeiconsIcon } from '@hugeicons/react'
import { Cancel01Icon } from '@hugeicons/core-free-icons'
import { useRef } from 'react'

import { useAppStore } from '@/store'

// Walk-mode HUD: an exit affordance, plus a thumb stick on touch.
//
// The stick writes straight into the viewer rather than through the store.
// It fires on every pointermove, and routing 60 updates a second through
// zustand would re-render this tree for a value only the camera reads.
export function WalkHud() {
  const walking = useAppStore((s) => s.walking)
  const exitWalk = useAppStore((s) => s.exitWalk)
  const viewer = useAppStore((s) => s.viewer)
  const stickRef = useRef<HTMLDivElement>(null)
  const knobRef = useRef<HTMLDivElement>(null)
  const pointerId = useRef<number | null>(null)

  if (!walking) return null

  const move = (e: React.PointerEvent) => {
    const stick = stickRef.current
    if (!stick || pointerId.current !== e.pointerId) return
    const rect = stick.getBoundingClientRect()
    const half = rect.width / 2
    const dx = Math.max(-1, Math.min(1, (e.clientX - (rect.left + half)) / half))
    const dy = Math.max(-1, Math.min(1, (e.clientY - (rect.top + half)) / half))
    if (knobRef.current) {
      knobRef.current.style.transform = `translate(${dx * half * 0.55}px, ${dy * half * 0.55}px)`
    }
    viewer?.setWalkInput(-dy, dx)
  }

  const release = (e: React.PointerEvent) => {
    if (pointerId.current !== e.pointerId) return
    pointerId.current = null
    if (knobRef.current) knobRef.current.style.transform = ''
    viewer?.setWalkInput(0, 0)
  }

  return (
    <>
      <button
        type="button"
        onClick={exitWalk}
        className="glass-pill pointer-events-auto fixed top-6 right-6 z-100 flex cursor-pointer items-center gap-2 px-3.5 py-2 text-sm font-medium"
      >
        <HugeiconsIcon icon={Cancel01Icon} size={15} strokeWidth={2} />
        Exit walk
      </button>

      <div
        ref={stickRef}
        onPointerDown={(e) => {
          pointerId.current = e.pointerId
          e.currentTarget.setPointerCapture(e.pointerId)
          move(e)
        }}
        onPointerMove={move}
        onPointerUp={release}
        onPointerCancel={release}
        className="glass pointer-events-auto fixed bottom-8 left-8 z-50 size-32 touch-none rounded-full sm:hidden"
      >
        <div
          ref={knobRef}
          className="bg-primary absolute top-1/2 left-1/2 size-12 -translate-x-1/2 -translate-y-1/2 rounded-full transition-transform duration-75"
        />
      </div>
    </>
  )
}
